/** What the reader is pointing at and has opened: shared by every lemma on the page and the index panel. */
import { reactive } from 'vue'
import { IndexLexeme, LayerWord } from '@/components/lemmas/renderer/wordLayer'
import { summary } from './api'

export interface Opened {
  surface: string
  lexeme: IndexLexeme
  /** The word it renders (or is rendered by) in this passage. */
  counterpart: IndexLexeme[]
  confident: boolean
}

export const indexState = reactive({
  hover: null as null | { word: LayerWord; x: number; y: number },
  opened: null as null | Opened,
  /** Earlier openings, for "back". */
  trail: [] as Opened[],
})

let prefetch: ReturnType<typeof setTimeout> | undefined

export const hoverWord = (word: LayerWord | null, el: HTMLElement | null) => {
  clearTimeout(prefetch)
  if (!word || !el) {
    indexState.hover = null
    return
  }
  const r = el.getBoundingClientRect()
  indexState.hover = { word, x: r.left + r.width / 2, y: r.bottom }
  const lexeme = word.lexeme
  if (lexeme) {
    // Resting on a word for a moment loads its index, so the click is instant.
    prefetch = setTimeout(() => summary(lexeme.language, lexeme.key).catch(() => undefined), 150)
  }
}

export const openLexeme = (next: Opened) => {
  if (indexState.opened) indexState.trail.push(indexState.opened)
  indexState.opened = next
  indexState.hover = null
}

export const openWord = (word: LayerWord) => {
  if (!word.lexeme) return
  openLexeme({ surface: word.surface, lexeme: word.lexeme, counterpart: word.counterpart, confident: word.confident })
}

export const back = () => {
  indexState.opened = indexState.trail.pop() ?? null
}

export const closeIndex = () => {
  indexState.opened = null
  indexState.trail = []
}
